export default [
  {
    path:'/',
    text:'Blog'
  },

  {
    path:'/about',
    text:'Timeline'
  },

  {
    path:'/contact',
    text:'contact'
  }
]